export const ButtonLinkTestIdFactory = {
    getButtonLinkBase: () => 'link-button',
    getButtonLinkTestId: (testId) => [ButtonLinkTestIdFactory.getButtonLinkBase(), testId].join('-'),
    getButtonLinkTextTestId: (testId) => [ButtonLinkTestIdFactory.getButtonLinkBase(), testId, 'text'].join('-'),
};
